import {
  Delete,
  Edit,
  Pause,
  PlayArrow,
  Fullscreen,
  FullscreenExit,
} from "@mui/icons-material";
import { Box, Chip, IconButton, Typography } from "@mui/material";
import { useState, useEffect } from "react";

interface StationData {
  station: {
    name: string;
  };
  time: string;
  nreTypeName: string;
  qcvnName: string;
}

interface LedHeaderProps {
  stationData: StationData;
}

const MonitoringFooter: React.FC<LedHeaderProps> = ({ stationData }) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleTogglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const toggleFullscreen = () => {
    if (!isFullscreen) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape" && document.fullscreenElement) {
        document.exitFullscreen();
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
        {stationData?.qcvnName && (
          <Typography variant="body2" color="white" sx={{ marginLeft: 2 }}>
            Theo {stationData.qcvnName}
          </Typography>
        )}
      </Box>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        {/* <IconButton onClick={handleTogglePlayPause} sx={{ color: "white" }}>
          {isPlaying ? <Pause /> : <PlayArrow />}
        </IconButton> */}

        <IconButton onClick={toggleFullscreen} sx={{ color: "white" }}>
          {isFullscreen ? <FullscreenExit /> : <Fullscreen />}
        </IconButton>
      </Box>
    </Box>
  );
};

export default MonitoringFooter;
